import { features } from '@/mocks/features';

export default function FeaturesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-14">
          <span className="inline-block text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
            Why Use Spreadsheet
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Smarter Product
            <br />
            <span className="font-light text-foreground-700">Discovery System</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100 rounded-2xl p-6 md:p-7 group hover:bg-background-100/80 transition-colors duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-6">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>

              <div className="mb-4">
                <span className="font-heading text-4xl font-bold text-foreground-950">{feature.stats}</span>
                <p className="text-xs text-foreground-500 mt-0.5">{feature.statsLabel}</p>
              </div>

              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-3">
                {feature.title}
              </h3>

              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}